export default "__VITE_ASSET__Cww4sVW5__"